(function(angular) {
    'use strict';

    angular.module("repairforms.app", [
        'repairforms.config.module',
        'repairforms.controller.module',
        'repairforms.factory.module',
        'repairforms.service.module',
        'repairforms.filter.module',
        'repairforms.modal.module',
        'repairforms.directive.module',
        'repairforms.constant.module',
        'repairforms.data.module',
        'pascalprecht.translate',
    ])
    .config(function($sceDelegateProvider) {
        $sceDelegateProvider.resourceUrlWhitelist([
            'http://www.bosch-professional.com/**',
            'http://static.bosch-professional.com/**',
            'self'
        ]);
    });



})(angular);

function setFieldValueFromToolbox(name, value) {
    angular.element(document.getElementById('repair-forms-page-form-controller')).scope().setScopeField(name, value);
}

function fixPrivacySettings() {
    var footerPresent = document.querySelector("footer") !== null;

    if (footerPresent === true) {
        if (typeof window.BoschPrivacy !== 'undefined') {
            // privacy settings via tealium are available

            var links = document.querySelectorAll("[data-show-privacy-settings]");
            for (i = 0; i < links.length; i++) {
                links[i].addEventListener(
                  'click',
                  function (e) {
                      window.BoschPrivacy.show();
                      e.preventDefault();
                  }
                );
            }
        } else {
            // privacy settings via tealium not available (yet)
            // if they load later, they will be able modify the footer link
        }
    } else {

        // footer not available yet
        window.setTimeout(fixPrivacySettings, 1000);
    }
}

window.setTimeout(fixPrivacySettings, 1000);